module.exports = __webpack_public_path__ + "img/poly.0423fad0.svg";